/* tslint:disable */
/* eslint-disable */
/* @relayHash 2212042b47c128d48dbd4f2cac0ae150 */

import { ConcreteRequest } from "relay-runtime";
export type UserStatusSitesListSelectedSiteQueryVariables = {
    siteID: string;
};
export type UserStatusSitesListSelectedSiteQueryResponse = {
    readonly site: {
        readonly name: string;
    } | null;
};
export type UserStatusSitesListSelectedSiteQuery = {
    readonly response: UserStatusSitesListSelectedSiteQueryResponse;
    readonly variables: UserStatusSitesListSelectedSiteQueryVariables;
};



/*
query UserStatusSitesListSelectedSiteQuery(
  $siteID: ID!
) {
  site(id: $siteID) {
    name
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "siteID"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "siteID"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UserStatusSitesListSelectedSiteQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Site",
                    "kind": "LinkedField",
                    "name": "site",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UserStatusSitesListSelectedSiteQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Site",
                    "kind": "LinkedField",
                    "name": "site",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "2212042b47c128d48dbd4f2cac0ae150",
            "metadata": {},
            "name": "UserStatusSitesListSelectedSiteQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '03bd32485ea83eba83c32abaa17c9541';
export default node;
